module.exports = __webpack_public_path__ + "img/set-up-code-coverage-136px.bcc66bc.png";